import React, { Component } from 'react'
import './Systems.css'
import * as languageSettings from '../Language/languageSettings'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Pagination from '../Common/Pagination'
import t from '../Language/language'
import { Config } from '../../Config'
import { initViewStore } from '../../actions/viewDetails'
import Api from '../../Api'
import { getSystems, sortSystems, setSearchParams, paginationSystems } from '../../actions/systems'
import Online from '../../images/connection_online.png'
import Offline from '../../images/connection_offline.png'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import CommonLoader from '../Alerts/CommonLoader'
import { CommonConstants } from '../../Constants'
import NavigationService from '../Common/NavigationServices'
import CommonSearch from '../Common/Search'
class Systems extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showStores: this.props.showStores,
      language: languageSettings.getCurrentLanguage(),
      Ascending: true,
      criteria: null,
      pageSize: 10,
      offset: 0,
      data: [],
      recordCount: 5000,
      showCommonLoader: true,
      isShowAll: false,
      infiniteScrollPageSize: Config.infiniteScrollPageSize,
      pageCounter: 0,
      selectedFilter: '',
      forcePage: null,
      searchOptions: [
        { value: 'Brand_Name', name: 'Search brand' },
        { value: 'Store_Number', name: 'Search store #' },
        { value: 'Device_SerialNumber', name: 'Search serial #' },
        { value: 'Device_MainVersion', name: 'Search system version' }
      ]
    }
    this.api = new Api()
    this.navigate = new NavigationService()
    this.PageSizeValueDropdown = this.PageSizeValueDropdown.bind(this)
    this.PageClicked = this.PageClicked.bind(this)
    this.search = this.search.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.send = this.send.bind(this)
    this.checkRegisteredSystem = this.checkRegisteredSystem.bind(this)
  }

  handleClick (did) {
    window.location.href = '/settings/stores/viewDetail?duid=' + did
  }

  componentWillMount () {
    // Intializing default sort
    this.props.sortSystems({ 'sortBy': 'Brand_Name', 'sortType': 'DESC' })
    this.props.setSearchParams({ 'filter': null, 'criteria': null })
    let self = this
    this.props.getSystems(function () {
      self.setState({ showCommonLoader: false, selectedFilter: '' })
    })
  }
  search (selectedFilter, criteria) {
    this.setState({ showCommonLoader: true, forcePage: 0, offset: 0 })
    let pageSize = this.state.pageSize
    if (criteria === '') {
      window.location.href = '/systems'
    }
    if (this.state.isShowAll) {
      pageSize = this.state.infiniteScrollPageSize
    }
    let paginationParams = {
      pageSize: pageSize,
      pageNumber: 1
    }
    this.setState({ pageSize: pageSize })
    this.props.paginationSystems(paginationParams)
    this.props.setSearchParams({ 'filter': selectedFilter, 'criteria': criteria })
    this.props.getSystems(() => {
      this.setState({ showCommonLoader: false })
    })
  }

  onEnterPress (e) {
    if (e.key === 'Enter') {
      if (this.state.criteria === '') {
        window.location.href = '/systems'
      }
      this.search()
    }
  }
  // handelling page size selection
  PageSizeValueDropdown (pageSize) {
    this.setState({ showCommonLoader: true, forcePage: 0, offset: 0 })
    let totalRecords = this.props.systems.systemDetails.pageDetails.RecordCount
    if (pageSize === totalRecords) {
      this.setState({ isShowAll: true })
      pageSize = this.state.infiniteScrollPageSize
    }
    let paginationParams = { pageSize: pageSize, pageNumber: 1 }
    this.setState({ pageSize, selectedFilter: '' })
    this.state.offset = Math.ceil((this.state.offset / 10) * pageSize)
    // this.state.offset = 0
    this.props.paginationSystems(paginationParams)
    let self = this
    this.props.getSystems(function () {
      self.setState({ showCommonLoader: false })
    })
  }

  // handelling page number clicks of pagination
  PageClicked (value) {
    this.setState({ showCommonLoader: true, selectedFilter: '', forcePage: null })
    let paginationParams = { pageSize: this.state.pageSize, pageNumber: ((value / this.state.pageSize) + 1) }
    this.setState({ pageNumber: paginationParams.pageNumber })
    this.props.paginationSystems(paginationParams)
    let self = this
    this.props.getSystems(function () {
      self.setState({ showCommonLoader: false })
    })
    if (value === null) {
      return this.state.offset
    } else {
      this.state.offset = value
      return this.state.offset
    }
  }
  handleCriteria (e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  renderTable () {
    let sortParams = (this.props.systems.sortParams) ? this.props.systems.sortParams : { 'sortBy': 'Brand_Name', 'sortType': 'DESC' }
    return (
      <div className='settings_table'>
        <Table>
          <Thead>
            <Tr className='theader clear'>
              <Th />
              <Th id='brand_space' className={(sortParams.sortBy === 'Brand_Name' && sortParams.sortType === 'ASC') ? 'actcol' : ((sortParams.sortBy === 'Brand_Name' && sortParams.sortType === 'DESC') ? 'actcold' : '')}>
                <a><span id='Brand_Name' onClick={this.sortStores.bind(this)}>Brand</span></a>
              </Th>
              <Th className={(sortParams.sortBy === 'Store_Number' && sortParams.sortType === 'ASC') ? 'actcol' : ((sortParams.sortBy === 'Store_Number' && sortParams.sortType === 'DESC') ? 'actcold' : '')}>
                <a><span id='Store_Number' onClick={this.sortStores.bind(this)}>Store #</span></a>
              </Th>
              <Th className={(sortParams.sortBy === 'Device_Name' && sortParams.sortType === 'ASC') ? 'actcol' : ((sortParams.sortBy === 'Device_Name' && sortParams.sortType === 'DESC') ? 'actcold' : '')}>
                <a><span id='Device_Name' onClick={this.sortStores.bind(this)}>System</span></a>
              </Th>
              <Th className={(sortParams.sortBy === 'Device_SerialNumber' && sortParams.sortType === 'ASC') ? 'actcol' : ((sortParams.sortBy === 'Device_SerialNumber' && sortParams.sortType === 'DESC') ? 'actcold' : '')}>
                <a><span id='Device_SerialNumber' onClick={this.sortStores.bind(this)}>Serial #</span></a>
              </Th>
              <Th className={(sortParams.sortBy === 'Device_MainVersion' && sortParams.sortType === 'ASC') ? 'actcol' : ((sortParams.sortBy === 'Device_MainVersion' && sortParams.sortType === 'DESC') ? 'actcold' : '')}>
                <a><span id='Device_MainVersion' onClick={this.sortStores.bind(this)}>Version</span></a>
              </Th>
              <Th className={(sortParams.sortBy === 'Device_SettingVersion' && sortParams.sortType === 'ASC') ? 'actcol' : ((sortParams.sortBy === 'Device_SettingVersion' && sortParams.sortType === 'DESC') ? 'actcold' : '')}>
                <a><span id='Device_SettingVersion' onClick={this.sortStores.bind(this)}>Settings Version</span></a>
              </Th>
              <Th className={(sortParams.sortBy === 'LaneConfig_Name' && sortParams.sortType === 'ASC') ? 'actcol' : ((sortParams.sortBy === 'LaneConfig_Name' && sortParams.sortType === 'DESC') ? 'actcold' : '')}>
                <a><span id='LaneConfig_Name' onClick={this.sortStores.bind(this)}>Lane Config</span></a>
              </Th>
              <Th id='systemStatusColumn' className={(sortParams.sortBy === 'Device_IsActive' && sortParams.sortType === 'ASC') ? 'actcol' : ((sortParams.sortBy === 'Device_IsActive' && sortParams.sortType === 'DESC') ? 'actcold' : '')}>
                <a><span id='Device_IsActive' onClick={this.sortStores.bind(this)}>System Status</span></a>
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {this.renderSystems()}
          </Tbody>
        </Table>
      </div>
    )
  }
  render () {
    const { language } = this.state
    let recordCount = (this.props.systems.systemDetails.pageDetails !== undefined) ? this.props.systems.systemDetails.pageDetails.RecordCount : 10
    let pageCount = (this.props.systems.systemDetails.pageDetails !== undefined) ? this.props.systems.systemDetails.pageDetails.TotalPages : 10
    return (
      <section className='systems'>
        <CommonLoader showLoader={this.state.showCommonLoader} message={'Loading...'} />
        <div className={'settings ' + (this.state.showCommonLoader ? 'hide' : 'show')} >
          <div className='settings_plug clear'>
            <div className='settings_search clear'>
              <h3 className='header'>{t[language].navbarSystems}</h3>
              <div className='systemsHeader'>
                <div><span className='additem' onClick={this.send}> {t[language].UnregisteredSystems}</span></div>
                <div >
                  <CommonSearch onSearch={this.search}
                    searchOptions={this.state.searchOptions} />
                </div>
              </div>
            </div> <div className='settings_plug clear storeHeight' />
            <div className='settings_list'>
              <div className='ctable'>
                {this.renderTable() }
                <Pagination
                  perPage={this.state.pageSize}
                  PageSizeValueChange={this.PageSizeValueDropdown}
                  offset={this.PageClicked}
                  loader={<h4>Loading...</h4>}
                  recordCount={recordCount}
                  pageCount={pageCount}
                  offSetValue={this.state.offset}
                  forcePage={this.state.forcePage} />
              </div>
            </div>
          </div>
        </div>

      </section>
    )
  }

  sortStores (e) {
    // sort on click of ASC or Desc icon
    if (this.state.isShowAll) {
      let pageSize = this.state.infiniteScrollPageSize
      let paginationParams = {
        pageSize: pageSize,
        pageNumber: 1
      }
      this.props.paginationSystems(paginationParams)
    }
    let Ascending = !this.state.Ascending
    this.setState({ showCommonLoader: true, selectedFilter: '', Ascending })
    let sortBy = e.target.id
    let sortType = this.state.Ascending ? 'DESC' : 'ASC'
    let sortParams = {
      'sortBy': sortBy,
      'sortType': sortType
    }
    this.props.sortSystems(sortParams)
    this.props.getSystems(() => {
      this.setState({ showCommonLoader: false })
    })
  }

  send (e) {
    // send an email when user clicks on email as CSV
    this.setState({ showCommonLoader: true })
    let url = Config.apiBaseUrl + CommonConstants.apiUrls.unRegisterDevices + '?reportType=csv'
    this.api.getData(url, data => {
      if (data.status) {
        this.setState({
          showCommonLoader: false
        })
        this.props.history.push('/emailSent', data.data)
      }
    }, error => {
      console.log(error)
    })
  }

  checkRegisteredSystem (store) {
    const { language } = this.state
    let self = this
    if (store.Store_Number !== null && store.Store_Number && store.Store_Number !== undefined) {
      return (
        <Td><a href='#' className='opener view_details' onClick={() => self.handleClick(store.Device_UID)}><span translate='' key='viewedit'>{t[language].settingsStoresViewDetails}</span></a></Td>
      )
    } else {
      return (<Td className='UnregisteredSystem'>N/A</Td>)
    }
  }

  // get the devices status
  renderStatus (device) {
    let self = this
    const { language } = this.state
    if (device.Device_IsActive === 1) {
      return (
        <span className='cstat'> <a style={{ 'fontSize': '14px', 'textAlign': 'center', color: parseInt(device.Device_IsActive) === 1 ? 'red' : 'black' }}
          href={self.navigate.getMenu('connect', device.Device_UID)} >
          { parseInt(device.Device_IsActive) === 1 ? t[language].settingsStoresOnline : t[language].settingsStoresOffline }
        </a> </span>)
    } else {
      return (<span className='cstat'> <span style={{ color: 'black' }}>{parseInt(device.Device_IsActive) === 1 ? t[language].settingsStoresOnline : t[language].settingsStoresOffline}</span></span>)
    }
  }

  renderSystems () {
    const { language } = this.state
    let self = this
    let deviceListArray = this.props.systems.systemDetails.deviceList
    if (this.props.systems && this.props.systems.systemDetails && this.props.systems.systemDetails.deviceList) {
      if (this.props.systems.systemDetails.pageDetails && (this.props.systems.systemDetails.pageDetails.RecordCount === 0 ||
        this.props.systems.systemDetails.pageDetails.RecordCount === undefined ||
        this.props.systems.systemDetails.pageDetails.RecordCount === null)) {
        return (
          <Tr className='tdata clear'>
            <Td colSpan='8'> <h3>{t[language].NoDeviceFound}</h3> </Td>
          </Tr>
        )
      } else {
        let storeRows = deviceListArray.map(function (store, index) {
          return (<Tr className='tdata clear'>
            {self.checkRegisteredSystem(store)}
            <Td>{store.Brand_Name}</Td>
            <Td>{store.Store_Number}</Td>
            <Td>{store.Device_Name}</Td>
            <Td>{store.Device_SerialNumber}</Td>
            <Td>{store.Device_MainVersion}</Td>
            <Td>{store.Device_SettingVersion}</Td>
            <Td>{store.LaneConfig_Name}</Td>
            <Td width='100'>
              <img src={Online} className={'cstat ' + (store.Device_IsActive == '1' ? '' : 'hidden')} alt='Device Online' />
              <img src={Offline} className={'cstat ' + (store.Device_IsActive == '0' ? '' : 'hidden')} alt='Device Offline' />
              {self.renderStatus(store)}
            </Td>
          </Tr>
          )
        })
        return storeRows
      }
    } else {
      return ''
    }
  }
}

function mapStateToProps (state) {
  return {
    systems: state.systems
  }
}
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      getSystems: getSystems,
      sortSystems: sortSystems,
      setSearchParams: setSearchParams,
      paginationSystems: paginationSystems,
      initViewStore: initViewStore
    }, dispatch
  )
}
export default connect(mapStateToProps, matchDispatchToProps)(Systems)



// WEBPACK FOOTER //
// ./src/components/Systems/Systems.js